import React, { ReactElement } from "react";
import ReactDom from "react-dom";
import { RouteComponentProps } from "react-router";
import { Dialer } from "../dialpad";

interface IParams {
	id?: string;
}

export const LeadPage = (props: RouteComponentProps<IParams>): ReactElement => {
	const portal = document.getElementById("lead-page-portal");
	let output;

	if (!portal) {
		throw Error("#lead-page-portal element could not be found");
	}

	if (!props.match.params.id) {
		throw Error("No Lead specified");
	}

	output = <Dialer leadId={props.match.params.id} />;

	return ReactDom.createPortal(output, portal);
};
